<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NoRealTaskManagementPage ref='NoRealTaskManagementPage' @changeTable="changeTable" @transferNe="transferNe" @transferMeasureObj="transferMeasureObj"></NoRealTaskManagementPage>
    </template>
    <template v-slot:right_view>
      <NoRealTaskListPage ref='NoRealTaskListPage' :queryParams="queryParams" :tableType="tableType" @refresh="refresh" ></NoRealTaskListPage>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import NoRealTaskListPage from '../../components/pmConfig/NoRealTask/NoRealTaskListPage';
import NoRealTaskManagementPage from '../../components/pmConfig/NoRealTask/NoRealTaskManagementPage';

export default {
  name: 'NoRealTaskPage',
  components: {
    BasicLayout,
    NoRealTaskListPage,
    NoRealTaskManagementPage
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t('Pm.exitTaskInfo')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.cycleMeasurement')}/${this.$t('Pm.noRealTaskManagement')}`
      },
      queryParams: {}, // 存放网元树或测量对象树点击信息，树类型通过treeType字段来区分，1：测量对象树 2：网元树
      tableType: 1 // 1、测量对象管理树  2、网元管理树
    };
  },
  methods: {
    // 测量对象树点击节点信息获取
    transferMeasureObj(msg) {
      this.queryParams = msg;
      this.$refs.NoRealTaskListPage.$refs.toolBar.input = '';
    },

    // 网元树点击节点信息获取
    transferNe(msg) {
      this.queryParams = msg;
      this.$refs.NoRealTaskListPage.$refs.toolBar.input = '';
    },

    // 网元树类型信息获取
    changeTable(tableType) {
      this.tableType = tableType;
      this.$refs.NoRealTaskListPage.$refs.gridForTaskList.initTaskList({ treeType: tableType });
      this.$refs.NoRealTaskListPage.$refs.toolBar.input = '';
    },
    refresh() {
      this.$refs.NoRealTaskManagementPage.$refs.MeasureTreeForTask.getMeasureObjectTree();
      this.$refs.NoRealTaskManagementPage.$refs.NeTreeForTask.getNeTree();
      this.$refs.NoRealTaskListPage.$refs.toolBar.input = '';
    }
  },
};
</script>

<style>

</style>
